<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['locale'])
  }
}
</script>
<template>
  <v-row class="justify-center text-center">
    <v-col>
      <v-icon color="warning">mdi-information</v-icon>
      <span
      ><slot></slot>
        <br />
        <v-btn
          id="routeToBaseData"
          :to="{
            name: 'profil',
            params: { locale: locale, tabName: 'contact' }
          }"
          color="primary"
          class="mt-2">
          {{ $t('button.invoice.data') }}</v-btn></span>
    </v-col>
  </v-row>
</template>
